<template>
    <b-form :save-url="addUrl" @success="formSuccess" v-slot="{model, loading}"
            :initial-data="initialData">

        <div class="row">
            <div class="col-12">
                <validated-input label="Testimonial User*" v-model="model.testimonial_user"
                                 :rules="{required: true, max:30}" :disabled="loading"/>
            </div>
            <div class="col-12">
                <validated-text-area label="Testimonial Description*" v-model="model.testimonial_description"
                                    :rules="{required: true, max:80}" :disabled="loading"/>
            </div>
            <div class="col-12">
                <file-input class="c-file-input" ref="file" @input="clearFile" label="Testimonial User Image"
                            v-model="model.testimonial_user_image"
                            :disabled="loading">
                    <template #append>
                        <div class="btn-group">
                            <btn v-if="initialData.testimonial_user_image"
                                 @click="viewFile(initialData.testimonial_user_image)"
                                 type="button" class="fa fa-eye" size="xs"/>
                        </div>
                    </template>
                </file-input>
            </div>
            <div class="col-12">
                <validated-input label="Order" type="number" v-model="model.order"
                                 :rules="{required: false, min_value:1}" :disabled="loading"/>
            </div>
            <div class="col-12">
                <validated-checkbox label="Enabled" v-model="model.is_enabled"
                                :rules="{required: false}" :disabled="loading"/>
            </div>
            <div class="col-12 text-right">
                <btn class="trn" size="sm" :loading="loading" color="primary" text="Update"
                     loading-text="Updating..." :disabled="loading"/>
            </div>
        </div>
    </b-form>
</template>

<script>
import urls from '@/data/cms-urls';

export default {
    name : 'EditTestimonial',

    props : { initialData : { type : Object } },

    data () {
        return {
            addUrl : urls.cms.testimonial.addEdit
        };
    },

    methods : {
        clearFile (file) {
            this.initialData.testimonial_user_image = '';
        },
        viewFile (file) {
            window.open(file);
        },
        formSuccess () {
            this.$notify('Successfully Edited Testimonial..!', 'Success',
                {
                    type : 'success'
                }
            );
            this.$emit('success');
        }
    }
};
</script>

<style scoped>

</style>
